module.exports = __webpack_public_path__ + "64a6979798d573554ad1c316ad6473da.png";